export const libraryTypeToWebComponentTypeMapping = {
    type: 'type',
    slots: 'slots',
    options: 'options',
    appServer: 'app-server',
    apiHost: 'api-host',
    authKey: 'auth-key',
    authToken: 'auth-token',
    contextId: 'context-id',
    canFilter: 'can-filter',
    filters: 'filters',
    dashboardId: 'dashboard-id',
    itemId: 'item-id',
    dashboardContentsVersion: 'dashboard-contents-version',
    libVersion: 'lib-version'
};
export const libraryAcceptedParametersList = ['appServer', 'apiHost', 'options', 'type', 'authKey', 'authToken', 'slots', 'filters', 'canFilter', 'contextId', 'itemId', 'dashboardId', 'libVersion'];
